// @flow
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { graphql, createRefetchContainer } from 'react-relay';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';

// material-ui
import { pipe } from 'fp-ts/lib/pipeable';
import { CircularProgress, Snackbar } from 'material-ui';
import { fold, none, some } from 'fp-ts/lib/Option';
import RaisedButton from 'material-ui/RaisedButton';
import IconEdit from 'material-ui/svg-icons/editor/mode-edit';
import Calendar from 'material-ui/DatePicker/Calendar';

import DateGrid from '../controls/dategrid/DateGrid';

import { backendUrl } from '../../lib/config';
import '../ui/paper.css';
import '../ui/wrapper.css';
import './epg-style.css';

type Props = {
	location: {
		hash: Object,
	},
	relay: Object,
	viewer: Object,
};

interface EpgState {
	currentDate: Date;
	isLoading: boolean;
	snackbarMessage?: string;
}

class Epg extends React.Component<Props, EpgState> {
	state = {
		currentDate: this.props.location.hash ? this.props.location.hash.replace('#', '') : new Date(),
		isLoading: false,
		snackbarMessage: none,
	};

	onUploadExcelFile = async event => {
		const file = event.target.files[0];
		const formData = new FormData();
		formData.append('file', file);
		this.setState({
			isLoading: true,
		});
		const response = await fetch(`${backendUrl}/import_excel`, {
			method: 'POST',
			body: formData,
		});
		const status = response.status;
		const result = await response.json();

		this.setState({
			isLoading: false,
		});

		if (status === 200) {
			this.dateChanged(new Date(result.message));
			document.location.reload();
		} else {
			this.setState({
				snackbarMessage: some(result.message || 'Системная ошибка'),
			});
		}

	};

	handleCloseSnackbar = () => {
		this.setState({
			snackbarMessage: none,
		});
	};

	dateChanged = d => {
		const formateDate = moment(d).format('YYYY-MM-DD');
		if (window.history.pushState) {
			window.history.pushState(null, null, `#${formateDate}`);
		} else {
			window.location.hash = formateDate;
		}
		this.props.relay.refetch({ day: formateDate }, null);
		this.setState({ currentDate: formateDate });
	};

	changeDate = (event: Object, date: Date) => {
		this.dateChanged(date);
	};

	render() {
		const { isLoading, snackbarMessage } = this.state;
		const { episodes } = this.props.viewer;
		return (
			<section className="wrapper epg-wrapper">
				{pipe(
					snackbarMessage,
					fold(
						() => null,
						message => (
							<Snackbar
								open={true}
								bodyStyle={{ backgroundColor: '#ef426f', height: 'auto', lineHeight: '16px', padding: 12, whiteSpace: 'pre-line' }}
								message={message}
								onRequestClose={this.handleCloseSnackbar}
							/>
						),
					),
				)}
				<div className="paper epg-list--wrapper">
					<header className="epg-list--grid-wrapper">
						<DateGrid value={this.state.currentDate} onChange={this.dateChanged} />
					</header>
					<ul className="epg-list--inner">
						{episodes && episodes.edges.map((edge, index) => <TextForItem item={edge.node} key={edge.id ? edge.id : index} />)}
					</ul>
				</div>
				<aside className="sidebar sidebar_paper epg-list--sidebar">
					<div className="epg-list--calendar">
						<Calendar
							DateTimeFormat={window.Intl.DateTimeFormat}
							firstDayOfWeek={1}
							hideCalendarDate
							locale="ru-RU"
							initialDate={new Date(this.state.currentDate)}
							onTouchTapDay={this.changeDate}
							minDate={new Date('2017-09-01')}
						/>
					</div>
					<div className="uploader">
						{isLoading ? (
							<div>
								<CircularProgress size={20} disableShrink={true} />
								<span>ИДЕТ ЗАГРУЗКА</span>
							</div>
						) : (
							<RaisedButton containerElement="label" disabled={isLoading} label="ЗАГРУЗИТЬ EXCEL">
								<input type="file" style={{ display: 'none' }} onChange={this.onUploadExcelFile} />
							</RaisedButton>
						)}
					</div>
				</aside>
			</section>
		);
	}
}

const TextForItem = (arg: Object) => {
	const { item } = arg;
	const time = moment(item.startDate).format('HH:mm');
	return (
		<li className="epg-list--item">
			<Link to={`/epg/${item.id}`} className="epg-list--link">
				<time className="epg-list--time" dateTime={time}>
					{time}
				</time>
				<span className="epg-list--title">
					{`${item.state === 'hidden' ? '(скрыта) ' : ''}
                    ${item.title.replace('»', '').replace('«', '')}`}
				</span>
				<span className="epg-list--icon">
					<IconEdit color="#4a206b" />
				</span>
			</Link>
		</li>
	);
};

export default withRouter(
	createRefetchContainer(
		Epg,
		graphql`
			fragment Epg_viewer on Viewer @argumentDefinitions(day: { type: String }) {
				episodes(first: -1, day: $day, showAll: true) {
					edges {
						node {
							id
							startDate
							endDate
							title
							state
						}
					}
				}
			}
		`,
		graphql`
			query Epg_Refetch_Query($day: String) {
				viewer {
					...Epg_viewer @arguments(day: $day)
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/epg/Epg.js